import React, { useState, useEffect } from 'react';
import { Button, Icon, CircularProgress, makeStyles } from '@material-ui/core';
import { useSnackbar } from "notistack";
import { Link } from 'react-router-dom';

import ownerService from '../../services/ownerService';
import ReviewReplyDialog from '../modals/ReviewReplyDialog';

const useStyles = makeStyles((theme) => ({
    btn: {
        padding: '8px 20px',
        textTransform: 'unset',
        color: '#566985',
        background: '#ffffff',
        border: '1px solid #e5e7f2',
        fontSize: '11px',
        fontWeight: '400'
    },
    button: {
        margin: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            minWidth: 32,
            paddingLeft: 8,
            paddingRight: 8,
            "& .MuiButton-startIcon": {
                margin: 0
            }
        }
    },
    buttonText: {
        [theme.breakpoints.down("sm")]: {
            display: "none"
        }
    }
}));

const ReviewOwnerBtns = (props) => {
    
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [loader, setLoader] = useState(false);
    const [isThanks, setThanks] = useState("");
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [selectedReview, setSelectedReview] = useState("")
    const [replyType, setReplyType] = useState("");
    const [confirmation, setConfirmation] = useState(false);

    useEffect(() => {
        if(props.review) {
            setThanks(props.review.is_thanks)
        }
    }, [props.review]);

    const submitThanks = (reviewId, replyType) => {
        
        setLoader(true)
        const formData = new FormData();            
        formData.append('review_id', reviewId)
        formData.append('reply_type', replyType)

        ownerService.storeReviewThanksReply(formData)
                .then((res) => {
                    setLoader(false)
                    if(res.data.success) {
                        setThanks(res.data.is_thanks)
                        enqueueSnackbar(res.data.message, {
                            variant: 'success',
                            autoHideDuration: 5000,
                        });
                    }
                })
                .catch((error) => {
                    setLoader(false)
                    if(error) {
                        enqueueSnackbar('Woop! something went wrong, please try again.', {
                            variant: 'error',
                            autoHideDuration: 5000,
                        });
                    }
                })
    }

    const handleDialogClose = () => {
	    setDialogIsOpen(false);
        setConfirmation(false);
	}

    const handleReviewReply = (rev, ttype) => {
        setReplyType(ttype);
        setSelectedReview(rev)
        setDialogIsOpen(true);
    }

    return (
        <>
            <div className="review-btns mt-4">
                <Button 
                    size="small" 
                    variant="outlined"
                    startIcon={isThanks && isThanks == 1 ? <Icon color="secondary">thumb_up</Icon> : <Icon>thumb_up_off_alt</Icon>}
                    className={classes.btn}
                    style={{ 
                        background: loader ? 'rgb(235,235,228)' : '#ffffff', 
                    }}
                    onClick={() => submitThanks(props.review.id, 'thanks')}
                    disabled={loader}
                >
                    {loader && 
                        <>
                            <CircularProgress size={24} /> 
                            <span className={classes.buttonText}>Processing...</span>
                        </>
                    }
                    {!loader &&
                        <span className={isThanks && isThanks == 1 ? `danger ${classes.buttonText}` : `${classes.buttonText}`}>Thanks</span>
                    }
                </Button>
                {/* to={`/biz/review/${props.review.id}/reply/public-comment`} */}
                <Link to="#">
                    <Button 
                        size="small" 
                        variant="outlined"
                        className={`ml-1 ${classes.btn}`}
                        startIcon={<Icon>chat_bubble_outline</Icon>}
                        onClick={() => handleReviewReply(props.review, 'public-comment')}
                    >
                        <span className={classes.buttonText}>Public Comment&nbsp;&nbsp;{props.review.replies.length > 0 ? props.review.replies.length : ""}</span>
                    </Button>
                </Link>
                {/* {props.review.replies.length > 0 && (
                    <Link to="#">
                        <Button
                            size='small'
                            className="ml-1" 
                        >
                            Show Reply
                        </Button>
                    </Link>
                )} */}
                {/* to={`/biz/review/${props.review.id}/reply/direct-message`} */}
                <Link to="#">
                    <Button 
                        size="small" 
                        variant="outlined"
                        startIcon={<Icon>mail_outline</Icon>}
                        className={`ml-1 ${classes.btn}`}
                        onClick={() => handleReviewReply(props.review, 'direct-message')}
                    >
                        <span className={classes.buttonText}>Direct Message</span>
                    </Button>
                </Link>
            </div>

            {selectedReview && replyType && (
                <ReviewReplyDialog 
                    dialogIsOpen={dialogIsOpen} 
                    handleDialogClose={handleDialogClose} 
                    setDialogIsOpen={setDialogIsOpen}
                    replyType={replyType}
                    review={selectedReview}
                    confirmation={confirmation} 
                    setConfirmation={setConfirmation}
                />
            )}
        </>
    );
};

export default ReviewOwnerBtns;